import { useMemo } from 'react';

import Character from './Character';
import { buildConfetti, Confetti, getTeamColor, getDanceForIndex } from './helpers';

// Shown after Update Scores succeeds. Each leading team gets a pair of
// dancing characters so the celebration reads as a team, not a single
// user. Both characters share the team's color but get different dances
// for visual variety.
export default function LeaderCelebration({ leadingTeams = [], roundName = '' }) {
  const confetti = useMemo(() => buildConfetti(60), []);

  return (
    <>
      <Confetti pieces={confetti} />
      <div className="celebration-header">
        <div className="celebration-kicker">
          {roundName ? `${roundName} — Current Leaders` : 'Current Leaders'}
        </div>
        <h1 className="celebration-title">Taking the lead.</h1>
        <div className="celebration-subtitle">
          {leadingTeams.length === 1
            ? `${leadingTeams[0].name} is out in front.`
            : `${leadingTeams.length} teams are leading their matchups.`}
        </div>
      </div>
      <div
        className={`celebration-characters-grid grid-pairs ${leadingTeams.length >= 8 ? 'grid-cap-8' : ''}`}
      >
        {leadingTeams.map((team, i) => {
          const teamColor = getTeamColor(team.name);
          return (
            <div key={team.id} className="celebration-character-cell" style={{ animationDelay: `${0.1 + i * 0.06}s` }}>
              <div className="celebration-character-pair">
                <Character
                  color={teamColor}
                  dance={getDanceForIndex(i * 2)}
                  pose="armsUp"
                  teamName={team.name}
                  showFlag
                  flagHand="left"
                  size="medium"
                />
                <Character
                  color={teamColor}
                  dance={getDanceForIndex(i * 2 + 1)}
                  pose="armsUp"
                  teamName={team.name}
                  showFlag
                  flagHand="right"
                  size="medium"
                />
              </div>
              <div className="celebration-character-sublabel">Winning</div>
              <div className="celebration-character-label">{team.name}</div>
            </div>
          );
        })}
      </div>
    </>
  );
}
